import request from "@/utils/request.js";
import requestAps from "@/utils/requset1.js";

/**
 * @param {Object} 个人信息
 */
export function getUserInfo(params) {
	return request({
		url: '/api/getUserInfo',
		method: 'get',
		params
	})
}


/**
 * @param {Object} 文件上传
 */
export function getUpload(params) {
	return request({
		url: '/api/upload',
		method: 'post',
		params
	})
}
/**
 * @param {Object} 身份认证提交接口
 */
export function addUpdataUserInfo(data) {
	return request({
		url: '/api/updateUserInfo',
		method: 'post',
		data
	})
}
/**
 * @param {Object} 验证身份证接口
 */
export function getCheck_id(url) {
	return request({
		url: '/api/common/app_check_id_card?imgUrl=' + url
	})
}
/**
 * @param {Object} 验证营业执照
 */
export function business_license(url) {
	return request({
		url: '/api/common/app_business_license?imgUrl=' + url
	})
}


/**
 * @param {Object} 获取省份
 */
export function getProvince(rand) {
	return request({
		url: '/api/getTargetsArea?rand=' + rand, ///getTargetsArea?rand=
		method: 'get',
	})
}
/**
 * @param {Object} 获取城市
 */
export function getCity(province_code) {
	return request({
		url: '/api/getCity.html?province_code=' + province_code,
		method: 'get',
	})
}

/**
 * @param {Object} 修改账号信息
 */
export function addForm(params) {
	return request({
		url: '/api/updateUserInfo',
		method: 'post',
		data: params
	})
}
/**
 * @param {Object} 验证码图片is_app: 1,
 */
export function getPicCode( is_app) {
	return request({
		url: '/api/getPicCode?is_app=' + is_app,
		method: 'get',
	})
}
/**
 * @param {Object} 获取手机验证码
 */
export function appAppCode(mobile) {
	return request({
		url: '/api/getAppCode?mobile=' + mobile,
		method: 'get',
	})
}
/**
 * @param {Object} 验证手机号是否正确
 */
export function getMobile(sms_code,mobile) {
	return request({
		url: '/api/getMobile?sms_code=' + sms_code + '&mobile=' + mobile,
		method: 'get',
	})
}
/**
 * @param {Object} 修改手机号
 */
export function appUserInfo(data) {
	return request({
		url: '/api/updateUserInfo',
		method: 'post',
		data
	})
}
/**
 * @param {Object} 密码修改
 */

export function appPassword(data) {
	return request({
		url: '/api/changePassword',
		method: 'post',
		data
	})
}